<app-alert />
<app-image-viewer />
<router-outlet/>